import React from "react";
import  moment from "moment";
import { convertAreaScheduleTime, convertDateAndTimeTimezonelll, convertUTCtoTimezone } from "../../../utility/utility";
import { currentData } from "../../../utility/constants/constants";
const momentTZ = require('moment-timezone');

const FrontLineTask = ({areaSearchResult, searchHistory, history, token, user, searchHistoryFilter, exportCleaningHistory}) => {
  const getFormattedZone = (timezone) => {
    let zone = ''
    const now = momentTZ.tz(timezone);
    zone = now.format('z');
    return '(' + zone + ')';
  }
const nextSchedule = (last) => {
  const now = moment();
  let nextScheduleDate = null;
  
  // Parse scanned_at properly for iOS
  let currentTime = now;
  if (last.scanned_at) {
    currentTime = moment(last.scanned_at, "MM-DD-YYYY h:mm a");
    if (!currentTime.isValid()) {
      console.warn("Invalid scanned_at date, using current time");
      currentTime = now;
    }
    currentTime = currentTime.isAfter(now) ? currentTime : now;
  }
  
  let nextSchedule = null;
  const currentDate = now.format("YYYY-MM-DD");
  
  // Check today's remaining timeslots
  last.area.timeslots.forEach(time => {
    const startTimeString = convertUTCtoTimezone(time.start_time_utc, last.timezone);
    const startTime = moment.tz(`${currentDate} ${startTimeString}`, "YYYY-MM-DD HH:mm:ss", last.timezone);
    
    if (last.last_sync && last.last_sync.timeslot_id !== time.id) {
      if (startTime.isAfter(currentTime) && !nextSchedule) {
        nextSchedule = startTime;
      }
    }
  });
  
  // If no timeslot found today OR you want to force next day, find next available day
  if (!nextSchedule) {
    let currentDay = now.day();
    let nextDay = last.area.days.find(a => a > currentDay);
    
    if (!nextDay) nextDay = last.area.days[0];
    
    let nextDate;
    if (nextDay > currentDay) {
      nextDate = now.clone().add(1, 'day').isoWeekday(nextDay);
    } else {
      nextDate = now.clone().add(1, 'week').isoWeekday(last.area.days[0]);
    }
    
    const timeString = convertUTCtoTimezone(last.area.timeslots[0].start_time_utc, last.timezone);
    nextScheduleDate = moment.tz(`${nextDate.format("YYYY-MM-DD")} ${timeString}`, "YYYY-MM-DD HH:mm:ss", last.timezone);
    console.log("restart next schedule", nextScheduleDate.format('lll'));
  } else {
    // FORCE NEXT DAY: Add this check to skip today
    if (nextSchedule.isSame(now, 'day')) {
      // If the found schedule is today, get tomorrow's first slot instead
      let currentDay = now.day();
      let nextDay = last.area.days.find(a => a > currentDay);
      
      if (!nextDay) nextDay = last.area.days[0];
      
      let nextDate;
      if (nextDay > currentDay) {
        nextDate = now.clone().add(1, 'day').isoWeekday(nextDay);
      } else {
        nextDate = now.clone().add(1, 'week').isoWeekday(last.area.days[0]);
      }
      
      const timeString = convertUTCtoTimezone(last.area.timeslots[0].start_time_utc, last.timezone);
      nextScheduleDate = moment.tz(`${nextDate.format("YYYY-MM-DD")} ${timeString}`, "YYYY-MM-DD HH:mm:ss", last.timezone);
      console.log("forced next day schedule", nextScheduleDate.format('lll'));
    } else {
      nextScheduleDate = nextSchedule;
      console.log("next schedule", nextScheduleDate.format('lll'));
    }
  }
  
  if (!nextScheduleDate || !nextScheduleDate.isValid()) {
    return "Next Schedule: Invalid Date";
  }
  
  return `Next Schedule ${nextScheduleDate.format('lll')} ${getFormattedZone(last.timezone)}`;
};
  // const lastCleaned = () => {
  //   searchHistory.last_sync.scanned_at = searchHistory.last_sync.scanned_at ? searchHistory.last_sync.scanned_at : searchHistory.last_sync.captured_time;
  //   let time = convertUtc(searchHistory.last_sync.scanned_at);
  // if (moment().diff(time, "hours") < 1) {
  //     let date = convertUtc(searchHistory.last_sync.scanned_at);
  //     var fromNow = date.fromNow();
  //     return   `${fromNow} , at ${time.format("hh:mm A")}`;
  //   }
  //   else return convertUtc(searchHistory.last_sync.scanned_at);;
  // };
  const lastCleaned = () => {
    searchHistory.last_sync.scanned_at = searchHistory.last_sync.scanned_at ? searchHistory.last_sync.scanned_at : searchHistory.last_sync.captured_time;
    let time = convertDateAndTimeTimezonelll(searchHistory.last_sync.scanned_at, searchHistory.timezone);
    debugger
    if (moment().diff(time, "hours") < 1) {
      let date = convertDateAndTimeTimezonelll(searchHistory.last_sync.scanned_at, searchHistory.timezone);
      var fromNow = moment(date).fromNow();
      const dateTime = momentTZ.tz(time, 'MMM D, YYYY h:mm A z', searchHistory.timezone);
      return   `${fromNow} , at ${dateTime.format("hh:mm A")}`;
    }
    else return convertDateAndTimeTimezonelll(searchHistory.last_sync.scanned_at, searchHistory.timezone);
  };
  return (
    <div className="frontline-content history_block mt-3 pt-2" style={{display: 'grid'}}>
     
      <h4 className="mb-2">
      {searchHistory && searchHistory.area ? <span style={{fontWeight: 'bold'}}>{searchHistory.area.account.name}</span> : ''} <span> &gt; </span> {searchHistory && searchHistory.area ? <>{searchHistory.area.name}</> : "" }
      </h4>
      {searchHistory && searchHistory.last_sync ? <>{searchHistory.last_sync.status === "not_cleaned" ? <div className="mt-3 front-line-task-block">Not cleaned at {lastCleaned()}</div> :  (searchHistory.last_sync.status === "not_available" ? <div className="mt-3 front-line-task-block">was In-use at {lastCleaned()}</div> : <div className="mt-3 front-line-task-block">Last cleaned {searchHistory.last_sync.area.account.hide_name ? "" : `by ${searchHistory.last_sync.user.first_name}`} - {lastCleaned()}</div>)}</> : <div className="mt-3 front-line-task-block">Not cleaned yet</div>}
      <div className="mt-1 front-line-task-block" style={{marginBottom: '10px'}}>{nextSchedule(searchHistory)}</div>
      <div style={{marginBottom: '10px'}}>
       {!user ? <><button className="btn btn_danger float-right" onClick={() => history.push(`/pegassure-feedback/${searchHistory.area.id}`)}>Leave Feedback</button>
       </> : "" } 
       </div>
      <div>
      {user && (
        <button className="btn btn_danger float-right mr-2 ml-2"onClick={() => exportCleaningHistory(searchHistoryFilter || { area_id: null, start_date: null, end_date: null }, token)}>Export CSV</button>
      )}
      {searchHistory && searchHistory.area && (!user || (user && user.role !== "frontline")) ? <><button className="btn btn_danger float-right" onClick={() => history.push(`/account/${token}/schedule`)}>View Schedule</button></> : "" }
      {!user || (user && user.role !== "frontline") ? <><button className="btn btn_danger desktop-btn-history float-right mr-2" onClick={() => history.push(`/account/${token}`)}>Back</button>
       </> : "" }
      </div>
    </div>
  )
};

export default FrontLineTask;